import { createContext, useContext, useEffect, useRef } from 'react'

export interface CoachingEditorState { dirty: boolean; saving: boolean }
export type CoachingEditorReporter = (key: string, state: CoachingEditorState) => void

/** Optional observer for a workspace. Legacy detail presentations do not provide it. */
export const CoachingEditorContext = createContext<CoachingEditorReporter | null>(null)

export function useCoachingEditorState(key: string, dirty: boolean, saving: boolean) {
  const reporter = useContext(CoachingEditorContext)
  const latest = useRef(reporter)
  latest.current = reporter
  useEffect(() => { latest.current?.(key, { dirty, saving }) }, [key, dirty, saving])
  useEffect(() => () => latest.current?.(key, { dirty: false, saving: false }), [key])
}
